import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ManagerClientsCountResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId: number | null;
};

const getManagerClientsCount = async ({ managerId }: Params) => {
  const { data } = await api.get<ManagerClientsCountResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/clients/count`
  );

  return data;
};

export const useGetManagerClientsCount = ({
  managerId,
}: Params): UseQueryResult<ManagerClientsCountResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.CLIENTS_COUNT, managerId],
    queryFn: () => {
      return getManagerClientsCount({ managerId });
    },
    enabled: managerId !== null,
  });
};
